<sirius-slider [layout]="'fluid'">
    @for (item of items; track $index) {
        <sirius-hero-old
            [mediaItem]="item.media"
            [title]="item.title"
            [textHtml]="item.textHtml"
            [button]="item.button"
            [layout]="item.layout"
            [subtitle]="item.subTitle"></sirius-hero-old>
    }
</sirius-slider>
